@let count = totalNotSyncItemsCount$ | async;
<div class="flex items-center gap-4">
  <mat-icon
    [class.text-red-500]="!isOnline()"
    [class.text-yellow-500]="isOnline()"
    [svgIcon]="isOnline() ? 'heroicons_solid:bolt' : 'heroicons_outline:bolt'"
  ></mat-icon>
  <button
    class="sync-start-btn min-w-0"
    mat-stroked-button
    [matBadge]="count"
    [disabled]="isLoading()"
    (click)="startSync()"
  >
    <div class="flex items-center">
      <mat-icon class="text-3xl" [class.animate-spin]="isLoading()"
        >sync</mat-icon
      >
      <p class="content">Sekronizasyonu Başlat</p>
      <p class="count-down" [class.loading]="isLoading()">
        {{ displayTime() }}
      </p>
    </div>
  </button>
</div>
